module.exports = __webpack_public_path__ + "img/figma.b47629c6.webp";